import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { NSTable } from 'bricks';
import { Link, generatePath } from 'react-router-dom';
import EmptyState from 'components/EmptyState/EmptyState';
import SortingIcon from 'components/DraggableTable/DraggableHeader/SortingIcon/SortingIcon';
import { ColSortConfig } from 'types/sort';
import { getSortingIconProps } from 'helpers/sort';
import { AttributeKey } from 'views/Reports/types';
import { URLS } from 'services/urls';

interface IDealsTableProps {
    selectedColumns: string[];
    colSortConfig: ColSortConfig<AttributeKey> | undefined;
    setColSortConfig: (config: ColSortConfig<AttributeKey> | undefined) => void;
    isEditMode: boolean;
    tableData: {
        id: number;
        values: string[];
    }[];
    enableDealLinks?: boolean;
}
const DealsTable = ({
    selectedColumns, tableData, colSortConfig, setColSortConfig, isEditMode, enableDealLinks = false,
}: IDealsTableProps) => {
    return (
        <>
            {selectedColumns.length === 0 && (
                <EmptyState
                    title="No columns added yet!"
                    subtitle="Add attributes as columns from the left sidebar to populate this area."
                    className="Pipeline-report__table-empty-state bg-transparent"
                />
            )}
            {tableData.length > 0 && (
                <OverlayScrollbarsComponent
                    defer
                    options={{
                        scrollbars: { autoHide: 'leave' },
                        overflow: { y: 'scroll' },
                    }}
                    className="OverlayScrollbarsComponent overflow-auto"
                >
                    <div className="NSTable--sticky-headers__table-container">
                        <NSTable className="NSTable NSTable--no-footer NSTable--sticky-headers NSTable--sticky-headers--full-width mb-1">
                            <thead className="NSTable__tbody__subheader">
                                <tr>
                                    {selectedColumns.map(col => (
                                        <th key={`header-cell-${col.split(' ').join('')}`}>
                                            <div className="d-flex justify-content-between align-items-center text-nowrap">
                                                <span>{col}</span>
                                                {isEditMode && (
                                                    <div className="ml-3">
                                                        <SortingIcon {...getSortingIconProps(col, colSortConfig, setColSortConfig)} />
                                                    </div>
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="NSTable__tbody text-white">
                                {tableData.map(deal => (
                                    <tr key={`row-${deal.id}`} className="NSTable__tbody__tr--level-3">
                                        {deal.values.map((cell, cellIdx) => {
                                            const isNameColumn = selectedColumns[cellIdx] === 'Name';
                                            let content;
                                            if (Array.isArray(cell)) {
                                                if (cell.length > 0) {
                                                    content = cell.map(value => (
                                                        <div key={`unit-value-${value}-for-${deal.id}`} className="text-nowrap">
                                                            {value === '' ? '-' : value}
                                                        </div>
                                                    ));
                                                } else {
                                                    content = <div className="text-nowrap">-</div>;
                                                }
                                            } else {
                                                const displayValue = cell === '' || cell === undefined ? '-' : cell;

                                                if (isNameColumn && enableDealLinks && displayValue !== '-') {
                                                    content = (
                                                        <Link to={generatePath(URLS.DEAL_DASHBOARD.HOME, { dealId: deal.id.toString(), tab: 'overview' })}>
                                                            {displayValue}
                                                        </Link>
                                                    );
                                                } else {
                                                    content = displayValue;
                                                }
                                            }
                                            return (
                                                <td key={`cell-${selectedColumns[cellIdx]}-for-deal_id-${deal.id}`}>
                                                    {content}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </NSTable>
                    </div>
                </OverlayScrollbarsComponent>
            )}
            {!tableData.length && selectedColumns.length && (
                <EmptyState
                    title="No results available for selected filter(s)."
                    subtitle="Modify your selected filter(s) to populate this screen with relevant information."
                    className="Pipeline-report__table-empty-state bg-transparent"
                />
            )}
        </>
    );
};

export default DealsTable;
